import "./index.css";
import Textarea from "../../../layout/Textarea/Textarea";
import {useEdits} from "../../../contexts/edits";
import {useSetting} from "../../../contexts/setting";
import {useImages} from "../../../contexts/images";
import BgTransformer from "../../../layout/BgTransformer";
import adsAssets from "../../../data/ads-assets.json";

const InstagramPostAds = ({id, zoom}) => {
  const {channel, product, type, bgOption, locked} = useSetting();
  const {customBgs} = useImages();
  const isLocked = locked.some((x) => x === id);
  // Per-template custom bg wins over the shared one (only when locked);
  // unlocking falls back to .main automatically.
  const customBgUrl = (isLocked ? customBgs[id] : undefined) || customBgs.main || null;
  const {titles, subtitles} = useEdits();
  const title = titles[id] || titles.main;
  const subtitle = subtitles[id] || subtitles.main;

  // Manifest miss is expected during channel-switch transitions (URL params
  // updated before useSetting commits) and for combos that haven't been baked
  // yet. Soft-fall-through: skip the background rather than crashing the page.
  const bgIdx = bgOption || 1;
  const assetKey = `${channel.value}/${product.value}/${type.value}/${bgIdx}/${id}`;
  const bgUrl = adsAssets[assetKey]?.url;

  return (
    <div id={id} className={`template ${type.value} tpl-card`} style={{"--zoom-level": zoom}}>
      <div className="tpl-card__inner">
        {customBgUrl || bgUrl ? <BgTransformer src={customBgUrl || bgUrl} id={id} /> : null}
        <div className="tpl-bubble">
          <h2 className="subtitle">
            <Textarea id={id} text={subtitle} />
          </h2>
          {/* AI tail = Figma 2044:31 (Vector 1, viewBox 64×73), fill via
           * currentColor matching the solid bubble.
           * DevEco tail = Figma 1429:925 (viewBox 65×75), fill via
           * userSpaceOnUse linearGradient aligned to the bubble's coord
           * frame (same approach as BlogPostAds). Two SVGs because the
           * viewBoxes differ by enough to cause visible curve drift if
           * forced into one. */}
          {type.value === "deveco" ? (
            <svg
              className="tpl-bubble__tail"
              viewBox="0 0 65 75"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <defs>
                <linearGradient
                  id="InstagramPostAds-deveco-tail-gradient"
                  gradientUnits="userSpaceOnUse"
                  x1="16.736"
                  y1="-126.066"
                  x2="615.359"
                  y2="60.965"
                >
                  <stop offset="0" stopColor="#211104" />
                  <stop offset="1" stopColor="#472407" />
                </linearGradient>
              </defs>
              <path
                d="M0 74.3302C0 74.3302 16.7939 29.2345 16.7939 0L65.0001 35.1436C41.0526 63.4451 0 74.3302 0 74.3302Z"
                fill="currentColor"
              />
            </svg>
          ) : (
            <svg
              className="tpl-bubble__tail"
              viewBox="0 0 64 73"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M0 73.0002C0 73.0002 16.4934 28.7114 16.4934 0L63.837 34.5147C40.318 62.3098 0 73.0002 0 73.0002Z"
                fill="currentColor"
              />
            </svg>
          )}
        </div>
        <h1 className="title">
          <Textarea id={id} text={title} />
        </h1>
      </div>
    </div>
  );
};

export default InstagramPostAds;
